module.exports = function(app){
	app.directive('cmsImg', ['aemContent', function(aemContent){
		return {
			restrict: 'A',
			scope: {
				contentId: '@cmsImg'
			},
			link: function($scope, element, attrs){
				if(element[0].tagName !== 'IMG'){
					console.error('You cannot use the cmsImg directive on non-image tags.');
				} else {
					aemContent.getQualifiedContent($scope.contentId).then(function(response){
						var image = JSON.parse(response);

						attrs.$set('src', image['src']);
						if ([null, ''].indexOf(image['src']) > -1) {
							attrs.$set('alt', image['alt']);
						}
					});
				}
			}
		};
	}]);
};